'use client';

import { useTranslations } from 'next-intl';
import { TestimonialsSection } from '@/app/components/ui/testimonials-with-marquee';
import { SITE } from '@/app/constants';
import { CHINA_TESTIMONIALS, GLOBAL_TESTIMONIALS } from './data';

export { CHINA_TESTIMONIALS, GLOBAL_TESTIMONIALS } from './data';

const TESTIMONIALS = SITE === 'china' ? CHINA_TESTIMONIALS : GLOBAL_TESTIMONIALS;

/**
 * 「用户声音」证言墙。标题/副标题复用 home3.creators（zh = 用户声音）。
 * 分国内 / 海外两份数据，喂给通用 TestimonialsSection（三列纵向滚动）。
 * 数据为空时整段不渲染——空列滚动只会露出一片空白背景。
 */
export const CreatorsMarquee = () => {
  const t = useTranslations('home3.creators');

  if (TESTIMONIALS.length === 0) return null;

  return <TestimonialsSection title={t('title')} description={t('subTitle')} testimonials={TESTIMONIALS} />;
};
